import BlueDotsBackground from '../../BlueDotsBackground';

export default function DataMigration() {
  return (
    <>
      <BlueDotsBackground />
      <section
        id="hero"
        className="relative text-center text-white overflow-hidden font-sans"
      >
        <div className="relative z-10 px-6 min-h-screen flex flex-col justify-center">
          <div className="max-w-5xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-semibold tracking-tight leading-tight mb-8">
              Worried about migrating legacy revenue data?
            </h1>
            <p className="text-lg md:text-2xl text-gray-300 font-light mb-12">
              Kernel ensures a seamless, validated data migration with integrity
              checks and mapping logic built specifically for pharma revenue
              workflows.
            </p>
            <div className="max-w-xl w-full mx-auto mb-20"></div>
          </div>
        </div>
      </section>
    </>
  );
}
